import request from 'sb-request'
import links from 'common/helpers/links'
import { reducers, getState } from 'redux/core'
import { shippingForm } from 'pages/paymentNew/SubscribePage/util/forms'
import { object, constants } from 'common/helpers'
import { getFeatureToggle } from 'helpers'
import { getBillData as getSubscribePageBillData } from 'pages/paymentNew/SubscribePage/util/bill'
import { getBillData as getRedeemQueuePageBillData } from 'pages/paymentNew/RedeemQueuePage/util/bill'
import { getBillData as getRedeemTossInPageBillData } from 'pages/paymentNew/RedeemTossInPage/util/bill'


const getAddressFieldValues = () => {
  const fieldNames = [ 'zipCode', 'state', 'city' ]
  // backend requires zipCode, state and city, so don't cancel request on invalid street
  const result = {
    street: shippingForm.fields.street.value,
  }

  const isValid = fieldNames.every((fieldName) => {
    result[fieldName] = shippingForm.fields[fieldName].value

    // should be valid or empty
    return shippingForm.fields[fieldName].isValid || !shippingForm.fields[fieldName].value
  })

  return {
    isValid,
    shipping: result,
  }
}

const inquireSubscription = (values) => {
  const { offer, coupon, subscriptionCase, couponCode, couponType = 'order', plan, isCouponFromUser = false } = values
  const { view: { pickPage: { selectedItems = [] } } } = getState()

  const { isValid, shipping } = getAddressFieldValues()

  if (!isValid) {
    // it's resolve coz all places awaits resolve only and checks if value exists
    return Promise.resolve(null)
  }

  const isPremiumProductsForNotSubscribedEnabled = getFeatureToggle(constants.features.premiumProductsForNotSubscribed)

  const query = {
    ...shipping,
    subscriptionCase,
    plan,
    forceLowerCouponValue: true,
  }

  if (isPremiumProductsForNotSubscribedEnabled && selectedItems.length) {
    query.pickedProducts = selectedItems.map(({ id }) => id).join()
  }

  if (offer) {
    query.offer = offer
  }

  if (coupon && coupon.id) {
    query.coupon = coupon.id
  }

  if (couponCode) {
    query.couponCode = couponCode
    query.couponFromUser = isCouponFromUser
  }

  if (couponType) {
    query.couponType = couponType
  }

  return request.get('rest/subscription/inquire', {
    query,
    multiple: false,
    modifyResult: (response) => {
      const {
        subscription, cart, discount, tax, price, upchargePrice,
        coupon: code, discountCode, offer, pickedProducts,
        subscriptionCasePrice, creditCardAuthorizationFee,
      } = response

      const couponData = discountCode && discountCode.code

      return {
        subscription: {
          ...object.removeKeys(subscription, [ 'tax' ]),
          price: subscription.price,
        },
        cart: cart || {},
        bill: {
          price,
          creditCardAuthorizationFee: creditCardAuthorizationFee || 0,
          upchargePrice,
          discount,
          offer,
          tax,
        },
        coupon: {
          code,
          isFetching: false,
          couponType: couponData && couponData.couponType,
          offerType: couponData && couponData.marketingCouponOfferType,
          errorMessage: discountCode && discountCode.errors && discountCode.errors[0] && discountCode.errors[0].message,
        },
        pickedProducts,
        subscriptionCasePrice,
      }
    },
  })
    .then(
      (data) => data,
      (err) => {
        if (isPremiumProductsForNotSubscribedEnabled) {
          const { error, outOfStockProducts } = err

          const isOutOfStockError = error === 'picked_out_of_stock'

          if (isOutOfStockError) {
            reducers.view.paymentPageNew.setOutOfStockProducts(outOfStockProducts)
          }
          else {
            console.error(err)
          }
        }
      }
    )
}

const setInquireFetchingStatus  = reducers.view.paymentPageNew.setInquireFetchingStatus
const setOutOfStockProducts     = reducers.view.paymentPageNew.setOutOfStockProducts
const setIsShippingValid        = reducers.view.paymentPageNew.setIsShippingValid
const setPaymentMethod          = reducers.view.paymentPageNew.setPaymentMethod

const setInquireAndBillData     = ({ gender, selectedPlan, inquireData, isFreeTrial }) => {
  const {
    routing: { location: { pathname } },
    view: { paymentPageNew: { paymentMethod } },
  } = getState()

  const getBillData = ({
    [links.subscribe]: getSubscribePageBillData,
    [links.queueRedeem]: getRedeemQueuePageBillData,
    [links.tossInRedeem]: getRedeemTossInPageBillData,
  })[pathname]

  if (getBillData) {
    const bill = getBillData({ ...inquireData, gender, paymentMethod, selectedPlan, isFreeTrial })

    reducers.view.paymentPageNew.setInquireAndBillData({ bill, inquireData })
  }
}


export default {
  inquireSubscription,
  setInquireFetchingStatus,
  setInquireAndBillData,
  setOutOfStockProducts,
  setIsShippingValid,
  setPaymentMethod,
}
